import React, { memo, useState } from 'react'
import { DatePicker, LocalizationProvider, DateTimePicker } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { faCalendar } from '@fortawesome/pro-light-svg-icons'
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz'

import { buildCustomHelperTextStyles } from '../../../util/style.helpers'
import CustomFormLabel from '../forms/customElements/CustomFormLabel'
import { DATE_PICKER_FORMAT } from '../../../constants/date'
import FaIcon from '../FaIcon/FaIcon'
import CustomTextField from '../forms/customElements/CustomTextField'

const timeZone = 'UTC'

const components = {
  DatePicker,
  DateTimePicker
}
const CustomDatePicker = ({
  bottomLabel,
  errorMessage,
  successMsg,
  size,
  id,
  label,
  minDateTime,
  minDate,
  inputFormat,
  disableFuture = false,
  enableTime = false,
  inputProps,
  value,
  onChange,
  ...restProps
}) => {
  const error = Boolean(errorMessage)
  const handleKeyEvent = (e) => {
    e.preventDefault()
  }

  const handleChange = (newValue) => {
    const utcDate = zonedTimeToUtc(newValue, timeZone)
    onChange(utcDate)
  }

  const [open, setOpen] = useState(false)
  const Component = components[enableTime ? 'DateTimePicker' : 'DatePicker']
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <CustomFormLabel htmlFor={id}>{label}</CustomFormLabel>
      <Component
        {...restProps}
        minDate={minDate}
        minDateTime={minDateTime && utcToZonedTime(minDateTime, timeZone)}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        disableFuture={disableFuture}
        components={{
          OpenPickerIcon: () => <FaIcon icon={faCalendar} size='xs' />
        }}
        renderInput={(params) => (
          <CustomTextField
            {...params}
            inputProps={{
              ...params.inputProps,
              ...inputProps
            }}
            error={error}
            size={size}
            fullWidth
            helperText={errorMessage || successMsg || bottomLabel}
            FormHelperTextProps={buildCustomHelperTextStyles(successMsg)}
            onKeyPress={handleKeyEvent}
            onKeyDown={handleKeyEvent}
            onKeyUp={handleKeyEvent}
            onCut={handleKeyEvent}
            onCopy={handleKeyEvent}
            onPaste={handleKeyEvent}
            onClick={() => setOpen(true)}
            id={id}
          />
        )}
        disableMaskedInput
        inputFormat={inputFormat || DATE_PICKER_FORMAT}
        onChange={handleChange}
        value={utcToZonedTime(value, timeZone)}
        ampm={false}
      />
    </LocalizationProvider>
  )
}

CustomDatePicker.defaultProps = {
  size: 'large'
}

export default memo(CustomDatePicker)
